<template>
  <form @submit.prevent="submit">
    <b-row>
      
      <b-col sm="4">

        <b-form-group label="Expotadora">
          <b-form-select
            :state="$v.processData.client_customer.$dirty ? !$v.processData.client_customer.$error : null"
            v-model="$v.processData.client_customer.$model"
            >
           <option value>Seleccione</option>
             <option
              v-for="customer in customers"
              v-bind:value="{ id: customer.value, text:customer.text }"
              >{{ customer.text }}</option>
           </b-form-select>


          <b-form-invalid-feedback id="input-1-live-feedback">
            Este campo es requerido.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Planta">
          
          <b-form-select
            id="plant"
            v-model="$v.processData.plant.$model"
            :state="$v.processData.plant.$dirty ? !$v.processData.plant.$error : null"
            @change="getProcessRooms"
            >
            <option value>Seleccione</option>
             <option
              v-for="plant in plants"
              v-bind:value="{ id: plant.value.id, text: plant.text }"
              >{{ plant.text }}</option>
           </b-form-select>


        </b-form-group>

         <b-form-group label="Sala/Línea">

        <b-form-select
            id="process_room"
             v-model="$v.processData.process_room.$model"
            :state="$v.processData.process_room.$dirty ? !$v.processData.process_room.$error : null"
            >
           
            <option value>Seleccione</option>
             <option
              v-for="process_room in process_rooms"
              v-bind:value="{ id: process_room.value, text: process_room.text }"
              >{{ process_room.text }}
              </option>

              </b-form-select>
        </b-form-group>

      </b-col>

    
      <b-col sm="4">

        <b-form-group label="Turno">
          <b-form-select
            id="shift"
            :state="$v.processData.shift.$dirty ? !$v.processData.shift.$error : null"
            v-model="$v.processData.shift.$model"
            >

            <option value>Seleccione</option>
             <option
              v-for="shift in shifts"
              v-bind:value="{ id: shift.value, text: shift.text }"
              >{{ shift.text }}
              </option>

          </b-form-select>
        </b-form-group>

         <b-form-group label="Supervisor">
          <b-form-select
            id="supervisor"
            :state="$v.processData.shift_supervisor.$dirty ? !$v.processData.shift_supervisor.$error : null"
            v-model="$v.processData.shift_supervisor.$model"
            >

            <option value>Seleccione</option>
             <option
              v-for="supervisor in supervisors"
              v-bind:value="{ id: supervisor.value, text: supervisor.text }"
              >{{ supervisor.text }}
              </option>

          </b-form-select>

        </b-form-group> 

      </b-col>

     
      <b-col sm="4">

        <b-form-group>
          <label for="shift_workers">Personal</label>
          <b-form-input
            type="number"
            :state="$v.processData.shift_workers.$dirty ? !$v.processData.shift_workers.$error : null"
            v-model="$v.processData.shift_workers.$model"
            id="shift_workers"
            placeholder="Número de personas trabajando en el turno">
            </b-form-input>
          <b-form-invalid-feedback id="shift_workers">
            Este campo admite sólo números enteros.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <label for="start_time">Hora de inicio</label>
      
          <datetime
            type="datetime"
            :state="$v.processData.start_time.$dirty ? !$v.processData.start_time.$error : null"
            v-model="$v.processData.start_time.$model"
            :minute-step="10"
             input-class="form-control"
             class="theme-orange"
            aria-describedby="input-start_time-live-feedback"
            id="start_time">
          </datetime>
          <b-form-invalid-feedback id="input-start_time-live-feedback">
            Hora de inicio es requerido
          </b-form-invalid-feedback>
          
        </b-form-group>

      </b-col> 
    </b-row>
  </form>
</template>

<script>
  import {required, numeric, minLength, between} from 'vuelidate/lib/validators'
  import {bus} from "../../main";

  export default {
    name: "ProcesoForm2",
    components: {},
    props: [
      "processData",
    ],
    data() {
      return {
        customers: [],
        plants: [],
        supervisors: [],
        shifts: [],
        process_rooms: []

      }
    },
    validations: {

      processData: {
        client_customer: {
          required
        },
        plant: {
          required
        },
        process_room: {
          required
        },
        shift: {
          required
        },
        shift_supervisor: {
          required
        },
        shift_workers: {
          required
        },
        start_time: {
          required
        }


      },
    },
    mounted() {
      this.getPlantsInfo();
      this.getCustomers();
    },

    methods: {
      getProcessRooms(a) {

        if (a.id != null) {

          this.processData.process_room = "";
          this.process_rooms = [];


          this.$axios.get('/production/get_plant_process_rooms/' + a.id)
            .then(res => {

              const rooms = [];

              for (let key in res.data.process_rooms) {
                const company = res.data.process_rooms[key];
                rooms.push(company);
              }

              this.process_rooms = rooms

            })
            .catch(error => console.log("Problemas al realizar la operacion"))


        } else {

          this.processData.process_room = "";
          this.process_rooms = [];

        }

      },
      getPlantsInfo(a) {
        this.$axios.get('/production/get_client_plants/')
          .then(res => {
            this.plants = res.data.plants;
            this.shifts = res.data.shifts;
            this.supervisors = res.data.workers;
          })
          .catch(error => console.log(errors))
      },
      getCustomers() {
        this.$axios.get('/production/get_customers/')
          .then(res => {
            this.customers = res.data.data
          })
          .catch(error => console.log(errors))
      },
      saveForm() {

        this.$v.$touch();
        if (this.$v.$invalid) {

          return 0;
        } else {


          const formData = {
            start_time: this.processData.start_time,
            end_time: this.processData.end_time,
            process_type: 2,
            shift: this.processData.shift.id,
            shift_workers: this.processData.shift_workers,
            shift_supervisor: this.processData.shift_supervisor.id,
            note: this.processData.note,
            material_waybill: this.processData.material_waybill,
            process_room: this.processData.process_room.id,
            client_customer: this.processData.client_customer.id,
            client: this.$store.getters.user.ID_CLIENTE
          };

          this.$axios.post('/api/v1/process/', formData)
            .then(res => {
              this.processData.id = res.data.id;
              this.processData.number = res.data.number;
            })
            .catch(error => console.log(error))


          return 1;
        }

      },
      updateProcess() {

        const formData = {
          id: this.processData.id,
          start_time: this.processData.start_time,
          end_time: this.processData.end_time,
          process_type: 2,
          shift: this.processData.shift.id,
          shift_workers: this.processData.shift_workers,
          shift_supervisor: this.processData.shift_supervisor.id,
          note: this.processData.note,
          material_waybill: this.processData.material_waybill,
          process_room: this.processData.process_room.id,
          client_customer: this.processData.client_customer.id,
          client: this.$store.getters.user.ID_CLIENTE
        };

        this.$axios.put('/api/v1/process/' + this.processData.id + '/', formData)
          .then(res => {

            this.processData.id = res.data.id;
            this.processData.number = res.data.number;
          })
          .catch(error => console.log(error))

      },

      submit() {
        // this.$v.$touch();
        // if (this.$v.$invalid) {
        //   this.$emit('validate', false)
        // } else {
        //   // do your submit logic here
        //   this.$emit('validate', true);
        // }
      },
    }
  }
</script>

<style>
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #20a8d8;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #20a8d8;
}
</style>
